<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :onClose="close">
        <br/>
        <div style="background: url(/images/onboarding/app-success-2.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 120px;"></div>

        <div style="margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Enable FREE access</h2>
        </div>

        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
            In order to use DentiCalc's FREE features provide us your name and email address.
        </p>
        <br/>
        <div style="flex-grow: 0; display: flex; text-align: left; justify-content: center; align-items: center; flex-direction: column; width: 100%; padding: 0 32px;">

            <v-text-field type="text" style="width: 100%; max-width: 300px;" ref="nameInput" id="feedback-name-input" outline v-model="username" :placeholder="$t('support.name')" />

            <v-text-field type="email" style="width: 100%; max-width: 300px;" ref="emailInput" id="feedback-email-input" outline v-model="email" :placeholder="$t('support.email')" />

            <div style="width: 100%; max-width: 300px; margin: -4px 0 20px 0; display: flex; justify-content: flex-start; align-items: center; font-size: 12px;">
                <input id="feedback-tos-input" ref="tosInput" type="checkbox" style="flex-shrink: 0; width: 20px; height: 20px; margin-right: 8px;" /> <span>I accept the <router-link to="/privacy-policy" v-on:click.native="visible=false">privacy policy.</router-link></span>
            </div>

            <span @click="submit" style="text-align: center; background: rgb(41, 121, 255); color: #fff; border: 2px solid #fff; text-transform: uppercase; margin: 0 0 16px 0; width: 100%; max-width: 300px; line-height: 38px; border-radius: 8px; box-shadow: 0 0 8px rgba(0,0,0,.15);">SUBMIT</span>
        </div>
    </pm-custom-dialog>
</template>

<style>
    #feedback-name-input {
        margin-top: 8px!important;
    }
    #feedback-email-input {
        margin-top: 8px!important;
    }
</style>
<script>
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        email: localStorage.getItem('userEmail') || "",
        username: localStorage.getItem('userName') || "",
        tosAccepted: false,
    }),
    created() {
        this.$bus.$on('user-profession-dialog:show', () => {
            this.show();
        });
    },
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmail", this.email);
        },
    },
    methods: {
        show() {
            this.visible = true;
        },
        close() {
            this.$router.push('/');
        },
        submit() {
            if (this.username.trim().length < 3) {
                this.$bus.$emit("app.showSnackbar", {text: 'Enter your full name', color: 'red'});
                this.$refs.nameInput.focus();
                return;
            }
            if (this.email.trim().length === 0 || !this.$IAP.isValidEmail(this.email)) {
                this.$bus.$emit("app.showSnackbar", {text: 'Enter your valid email address', color: 'red'});
                this.$refs.emailInput.focus();
                return;
            }
            if (!this.$refs['tosInput'].checked) {
                this.$bus.$emit("app.showSnackbar", {text: 'Please accept the privacy policy', color: 'red'});
                return;
            }
            this.callSlackWebhook();
            this.visible = false;
        },
        callSlackWebhook() {
            const text = this.username + " (" + this.email + ")";

            fetch("https://hooks.slack.com/services/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", {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                "body": JSON.stringify({
                        "username": "DentiCalc user email entered",
                        "icon_url": "https://public.app.denticalc.com/images/denti_calc_icon.png",
                        "text": text,
                        "channel": "#registrations",
                    }),
                })
                .then(console.log)
                .catch(captureException);
        },

    }
}
</script>
